//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSkillTypes, getReuseLevel } from '@/util/skill'

export default {
  name: 'WorkerSkillsInventoryTable',
  props: {
    skills: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    calculate() {
      return this.skills.length === this.perPage
        ? `${this.skills.length * this.currentPage - (this.perPage - 1)}-${
            this.skills.length * this.currentPage
          }`
        : `Últimos ${this.skills.length}`
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit('page-change', page)
    },
    getSkillTypes(code) {
      return getSkillTypes(code)
    },
    getReuseLevel(reuseLevel) {
      return getReuseLevel(reuseLevel)
    },
  },
}
